import Vue from 'vue'
import Vuex from 'vuex'
import Db from '../api/db'
import url from '../config/url'
Vue.use(Vuex)
let db = new Db()
export default new Vuex.Store({
  state: {
    web_info: {},
    web_channel: {},
  },
  mutations: {
    web_info: (state, data) => {
      state.web_info = data
    },
    web_channel: (state, data) => {
      state.web_channel = data
    }
  },
  actions: {
    //获取导航信息
    getChannelInfo({
      commit
    }) {

      db.webChannel().then(res => {
        if (res && res.code == 200) {
          commit('web_channel', res.data)
        }
      })

    },

    //获取网站信息
    getWebInfo({
      commit
    }) {

      db.webInfo().then(res => {
        if (res.code == 200) {

          if (res.data.ifclose == 2) {
            console.log('网站已关闭了！');
          }
          document.title = res.data.website_title ? res.data.website_title : "湖南爱眼公益基金会"
          commit('web_info', res.data)
        }
      })

    },
  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js